import { format } from "date-fns";
import fileDownload from "js-file-download";
import { jsonToCSV } from "react-papaparse";
import { type InputRow, type MatchedRow } from "./types";
import { toRowView } from "./rowView";

const headers = [
  "レコード",
  "入力した法人名",
  "入力した都道府県",
  "入力した市区町村",
  "入力した町名",
  "入力した法人番号",
  "入力した会社法人等番号",
  "特定した法人名",
  "特定した法人番号",
  "特定した会社法人等番号",
  "特定した所在地",
  "ステータス",
  "取得対象",
  "一致理由",
];

/** 照合結果をCSVの文字列にする。ExcelでUTF-8として開けるよう、先頭にBOMを付ける */
export const buildCorporationCsv = (
  rows: MatchedRow[],
  inputs: InputRow[]
): string => {
  const byNumber = new Map(inputs.map((input) => [input.rowNumber, input]));
  const lines = rows.map((row) => {
    const input = byNumber.get(row.rowNumber);
    const view = toRowView(row, input);
    const corporation = row.corporation;
    return [
      String(row.rowNumber),
      input?.companyName ?? "",
      input?.prefectureName ?? "",
      input?.cityName ?? "",
      input?.townName ?? "",
      input?.corporateNumber ?? "",
      input?.corporateIdentificationNumber ?? "",
      corporation?.companyName ?? "",
      corporation?.corporateNumber ?? "",
      corporation?.corporateIdentificationNumber ?? "",
      corporation
        ? `${corporation.prefectureName}${corporation.cityName}${corporation.streetNumber}`
        : "",
      view.status,
      view.target,
      view.reasons.join(" / "),
    ];
  });
  const csv = jsonToCSV([headers, ...lines], {
    quotes: true,
    newline: "\r\n",
    // 顧客の入力値をExcelで開くため、空白の後にある数式も無害化する。
    escapeFormulae: /^(?:\s*[=+\-@]|[\t\r\n])/,
  });
  return `\uFEFF${csv}\r\n`;
};

/** 照合結果のCSVをブラウザーでダウンロードさせる */
export const downloadCorporationCsv = (
  rows: MatchedRow[],
  inputs: InputRow[],
  now: Date = new Date()
): void => {
  fileDownload(
    buildCorporationCsv(rows, inputs),
    `法人確認結果_${format(now, "yyyyMMdd")}.csv`,
    "text/csv;charset=utf-8"
  );
};
